<template>
  <div class="workspace new-back">
    <div class="section-heading">
      <h2>Campaigns</h2>
      <a href="/create-campaign"><div class="al-button"><i class="fas fa-plus-square"></i> Create Campaign</div></a>
    </div>
    <div class="flex-area" style="float: left">
      <div  v-for="(item, index) in posts" :key="index" class="campaign-box">
        <card-item :callback="fetchFeed" :data="item" :setPostInfo="setPostInfo" />
      </div>
    </div>
    <div class="flex-area" style="float: right;float: right; position: fixed; left: 70%; top: 11%;">
      <div v-if="show_preview" class="qr-field w-100">
        <div class="preview-wrapper">
          <h2 class="new-preview-flex">Preview</h2>
          <div class="flex new-flex">
            <span class="new-span">Form</span>
            <vs-switch class="switch-button mx-2" v-model="preview_switch" />
            <span class="new-span">Scratch</span>
          </div>
          <div id="campaign-preview">
            <div class="campaign-live-preview" ref="preview"
                 :style="main_style" v-if="!preview_switch">
              <section id="campaign-logo" class="form-module">
                <div class="campaign-logo" ref="campaignLogo">
                  <img :src="(logo_id) ? `https://restapi.authorizelocal.com/api/posts/photo/${this.logo_id}` : '/img/yourlogohere.jpg'"/>
                </div>
              </section>
              <section id="campaign-slogan" class="form-module" ref="campaignSlogan">
                <h2 :style="slogan_style">{{ (title) ? title : 'Campaign Slogan Here' }}</h2>
              </section>
              <section id="campaign-award" class="form-module" ref="campaignAward">
                <p><span :style="award_style" class="popout">{{ (offer) ? offer : 'campaign award text here' }}</span></p>
              </section>
              <section id="campaign-award-visual" class="form-module" ref="campaignAwardVisual">
                <img :src="(campaign_image_id) ? `https://restapi.authorizelocal.com/api/posts/photo/${this.campaign_image_id}` : '/img/awardvisual.jpg'"/>
              </section>
              <section id="data-collection" class="form-module" ref="fieldList">
                <div v-for="(option, option_index) in fieldList" :key="option_index" >

                  <label :style="label_style">{{fieldnames.filter(x => x.code === option)[0].name}}
                    <input class="al-input" :type="fieldnames.filter(x => x.code === option)[0].type" :placeholder="fieldnames.filter(x => x.code === option)[0].name"></label>
                </div>
              </section>
            </div>
            <div class="campaign-live-preview" v-else>
              <scratch-preview :show-prize-placeholder="showScratch"/>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import CardItem from './components/CardItem'
import ScratchPreview from '@/views/pages/CreateCampaign/components/ScratchPreview.vue'
export default {
  data () {
    return {
      show_preview: true,
      preview_switch: false,
      showScratch: true,
      name: '',
      logo_id: '',
      title: '',
      offer: '',
      campaign_image_id: '',
      fieldnames: [
        {
          name: 'Name',
          type: 'text',
          code: 'name',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          type: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          type: 'email',
          value: false
        },
        {
          name: 'Birthday',
          code: 'birthday',
          type: 'date',
          value: false
        },
        {
          name: 'ZIP Code',
          code: 'address',
          type: 'text',
          value: false
        },
        {
          name: 'Web Site',
          code: 'website',
          type: 'text',
          value: false
        }
      ],
      fieldList: ['email'],
      prizeList: []
    }
  },
  metaInfo () {
    return {
      title: 'Campaings',
      titleTemplate: '%s - AuthorizeLocal',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Manage your campaigns'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Local SEO Solutions'
        }
      ]
    }
  },
  components: {
    ScratchPreview,
    CardItem
  },
  mounted () {
    this.getFeed()
  },
  watch: {
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    posts () {
      return this.$store.state.posts
    },
    qr_url () {
      const domain = window.location.origin
      return `${domain}/scratch/${this.data.slug}`
    },
    short_qr_url () {
      return `https://authlocal.com/${this.data.slug}`
    },
    label_style () {
      if (this.campaign_theme && this.campaign_theme.labels) {
        return `color: ${this.campaign_theme.labels.color}; font-size: ${this.campaign_theme.labels.size}px; font-weight: ${this.campaign_theme.labels.weight};`
      } else {
        return ''
      }
    },
    main_style () {
      if (this.campaign_theme) {
        if (this.isObject(this.campaign_theme.main)) {
          return `background: url(${this.getImage(this.campaign_theme.main.url)})`
        } else if (this.campaign_theme.main !== '') {
          return `background: ${this.campaign_theme.main}`
        }
      }
      return ''
    },
    award_style () {
      if (this.campaign_theme && this.campaign_theme.award) {
        return `color: ${this.campaign_theme.award.color}; font-size: ${this.campaign_theme.award.size}px; font-weight: ${this.campaign_theme.award.weight};`
      } else {
        return ''
      }
    },
    slogan_style () {
      if (this.campaign_theme && this.campaign_theme.slogan) {
        return `color: ${this.campaign_theme.slogan.color}; font-size: ${this.campaign_theme.slogan.size}px; font-weight: ${this.campaign_theme.slogan.weight};`
      } else {
        return ''
      }
    },
    post_detail () {
      return this.$store.state.post_detail
    },
    campaign_theme () {
      return this.$store.state.campaign_theme
    }
  },
  methods: {
    setPostInfo () {
      const { name, logo_id, title, offer, campaign_image_id, fieldList, campaign_theme } = JSON.parse(JSON.stringify(this.post_detail))
      this.name = name
      this.logo_id = logo_id
      this.title = title
      this.offer = offer
      this.campaign_image_id = campaign_image_id
      this.fieldList = fieldList

      if (campaign_theme) {
        this.$store.commit('SET_CAMPAIGN_THEME', campaign_theme)
      }


      this.fieldList.map((item) => {
        this.fieldnames.filter((field, index) => {
          if (item === field.code) {
            this.fieldnames[index].value = true
          }
          return field
        })
      })

      this.showLayout = true
    },
    getImage (url) {
      return `https://restapi.authorizelocal.com/api/posts/photo/${url}`
    },
    isObject (a) {
      return (!!a) && (a.constructor === Object)
    },
    fetchFeed () {
      this.getFeed()
    },
    getFeed () {
      const payload = {
        page: 0
      }
      if (this.activeUserInfo.permissionLevel === 2048) {
        const selectedUser = localStorage.getItem('selectedUser')
        if (selectedUser) {
          if (selectedUser !== 'null') {
            payload.author = JSON.parse(selectedUser)._id
          }
        }
      }
      this.$store.dispatch('getPosts', payload)
        .then((response) => {
          console.log('success campaigns', response)
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss">
.preview-wrapper {
  .vs-switch{
  background-color:#005488;
    border-radius: 12px
  }
}
.preview-wrapper{
  .vs-switch-active{
  background-color:#f28129;
  }
}
.campaign-box {
  border-radius: 12px;
  background: #FFF;
  box-shadow: 0px 0px 20px 0px rgba(0, 52, 81, 0.20);
}
.section-heading {
  border-bottom: none;
  width: 554px;

}
.section-heading>h2 {
  color: var(--Main-Color-Main-100, #003451);
  font-variant-numeric: lining-nums proportional-nums;

  /* Heading Styles/H1 */
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px; /* 137.5% */
}
.flex-area {
  width: 600px;
}
.new-back {
  background-color: transparent;
  border: none;
  margin-left: 20px;
}
.new-flex {
  padding-left: 90px
}
.new-preview-flex {
  padding-left: 120px;
  color: var(--Main-Color-Main-100, #003451);
  font-variant-numeric: lining-nums proportional-nums;

  /* Heading Styles/H3 */
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */
}
.new-span {
  color: var(--Main-Color-Main-80, #006495);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.32px;
}
</style>
